export const getRestaurantDetail = async (restaurantId: number) => {
  const res = await fetch(`/api/restaurant?id=${restaurantId}`)
  return res.json()
}

export const getRestaurantItemDetail = async (dishId: number) => {
  const res = await fetch(`/api/restaurant/dish?dish_id=${dishId}`)
  return res.json()
}

export const getFavoriteRestaurants = async (
  latitude?: number,
  longitude?: number,
  page: number = 1,
  limit: number = 15
) => {
  const res = await fetch("/api/favorite-restaurants", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      latitude,
      longitude,
      page,
      limit,
    }),
  })
  return res.json()
}
